import { Link } from "react-router-dom";
import { ArrowUpRight, BookOpen } from "lucide-react";
import { cardImage } from "@/lib/img";
import SmartImage from "@/components/SmartImage";
import ShareButton from "@/components/ShareButton";

export default function ArticleCard({ article, index = 0 }) {
  return (
    <div className="relative group">
    <Link to={`/guides/${article.slug}`} data-testid="article-card"
      className="h-full group bg-white rounded-xl border border-neutral-200 overflow-hidden flex flex-col hover:shadow-md hover:-translate-y-1 transition-[transform,box-shadow] duration-200 fade-up"
      style={{ animationDelay: `${Math.min(index * 60, 400)}ms` }}>
      <div className="relative aspect-[16/10] overflow-hidden bg-neutral-100">
        {article.image_url ? (
          <SmartImage src={cardImage(article.image_url, 600)} alt={article.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
        ) : (
          <div className="w-full h-full flex flex-col items-center justify-center gap-1 bg-gradient-to-br from-ink-950 via-ink-900 to-brand text-white">
            <BookOpen className="w-8 h-8 opacity-80" />
            <span className="font-display font-bold text-lg tracking-tight">gk<span className="text-[#FFE14D]">deals</span></span>
            <span className="text-[10px] tracking-[0.2em] uppercase opacity-70">{article.category || "Guide"}</span>
          </div>
        )}
      </div>
      <div className="p-5 flex flex-col flex-1">
        {article.category && <span className="text-xs tracking-[0.15em] uppercase font-bold text-brand mb-2">{article.category}</span>}
        <h3 className="font-display font-semibold text-lg text-ink-900 leading-snug line-clamp-2 mb-2 group-hover:text-brand transition-colors">{article.title}</h3>
        <p className="text-sm text-neutral-500 line-clamp-2">{article.excerpt}</p>
        <span className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-ink-950 group-hover:text-brand transition-colors">Read guide <ArrowUpRight className="w-4 h-4" /></span>
      </div>
    </Link>
    <div className="absolute bottom-4 right-4">
      <ShareButton path={`/guides/${article.slug}`} title={article.title} image={article.image_url} testid="article-card-share" />
    </div>
    </div>
  );
}
